import { getInvoiceInfoAPI } from "@/api/";
import AlertModule from 'vux/src/plugins/alert/module'

import { afterGetInvoiceMsg } from "./invoice";
import * as dd from "dingtalk-jsapi"; 

export async function openScanInvoice(vm, invoicePeriod, company, id) {
dd.ready(() => {
ddScan(vm, invoicePeriod, company, id);
});

dd.error(async (error) => {});
}

export async function ddScan(vm, invoicePeriod, company, tenantId) {
dd.biz.util.scan({
type: "all", // type 为 all、qrCode、barCode，默认是all。
onSuccess: async (data) => {
try {
let saomaojieguo = data.text.toString();
if (saomaojieguo.indexOf(",") !== -1) {
const saomiaoArr = saomaojieguo.split(",");
if (saomiaoArr.length >= 6) {
if (saomiaoArr[3].length == 8) {
const res = await getInvoiceInfoAPI({
customId: company.qyid,
resStr: saomaojieguo,
scan: true,
nsrsbh: company.nsrsbh,
customName: company.qymc,
kjqj: invoicePeriod,
tenantId: tenantId,
});
console.log("res", res);
res.invoiceSubmit = saomaojieguo;
afterGetInvoiceMsg(vm, res);
} else {
layer.open({
content: "发票二维码不符合规则",
skin: "msg",
time: 2, //2秒后自动关闭
});
}
} else {
layer.open({
content: "发票二维码不符合规则",
skin: "msg",
time: 2, //2秒后自动关闭
});
}
} else {
layer.open({
content: "发票二维码不符合规则",
skin: "msg",
time: 2, //2秒后自动关闭
});
}
} catch (error) {
console.log("error", error);
}
},
onFail: function (err) {
AlertModule.show({
title: "钉钉错误",
content: `${JSON.stringify(err)}`,
hideOnBlur: true,
dialogTransition: "rotateIn",
});
},
});
}



// WEBPACK FOOTER //
// ./src/utils/dingding.js